<template>
    <!-- BaseAppFooter.vue -->
    <v-footer
        absolute
        app
        dark
        inset
        padless
    >
        <v-card
            color="accent"
            dark
            flat
            tile
            width="100%"
        >
            <v-card-text class="text-center">
                <v-btn
                    v-for="link in socialMediaLinks"
                    :key="link.href"
                    :href="link.href"
                    :title="link.title"
                    class="mx-4"
                    icon
                    target="_blank"
                >
                    <v-icon size="24px">{{ link.icon }}</v-icon>
                </v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="text-center">
                {{ titleFormatted }}
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: 'BaseAppFooter',
        props: {
            /**
             * The footer color
             */
            color: {
                type: String,
                default: 'accent'
            },
            /**
             * The footer title
             */
            title: {
                type: String,
                required: true
            },
            /**
             * The version number
             */
            version: {
                type: String,
                default: ''
            },
            /**
             * The width of the footer
             */
            width: {
                type: String,
                default: '100%'
            }
        },
        computed: {
            socialMediaLinks () {
                return [
                    {
                        icon: 'mdi-facebook',
                        href: 'https://www.facebook.com/WindsorTelecom',
                        title: 'Windsor Telecom Facebook'
                    },
                    {
                        icon: 'mdi-twitter',
                        href: 'https://twitter.com/windsortelecom',
                        title: 'Windsor Telecom Twitter'
                    },
                    {
                        icon: 'mdi-linkedin',
                        href: 'https://www.linkedin.com/company/windsor-telecom',
                        title: 'Windsor Telecom LinkedIn'
                    },
                    {
                        icon: 'mdi-youtube',
                        href: 'https://www.youtube.com/user/windsortelecom',
                        title: 'Windsor Telecom Youtube'
                    }
                ]
            },
            titleFormatted () {
                const vm = this

                if (vm.version) {
                    return `${vm.title} v${vm.version}`
                }

                return vm.title
            }
        }
    }
</script>
